import NTab from './NTab';

export default NTab